import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import isIos from "is-ios";
import { Container, Row, Col, Button } from "reactstrap";
import Banner from "../components/Banner/Banner";
import * as vars from "../constants/variables";
import { setHeaderTitle } from "../actions/HeaderActions";
import { getDetails, getInterests } from "../actions/AccountActions";
import { show, hide } from "../actions/ActivityIndicatorActions";
import { checkAccess } from "../actions/WelcomeActions";
import {
  console_log,
  parseQueryString,
  appendUid,
  loggedInDetail,
} from "../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../constants/domainConfig";
import { Route, Redirect } from "react-router";
import { sendData } from "../analytics/sendData";
import { isGamiclub } from "../constants/isGamiclub";
import { isOnlyMobbfun } from "../constants/isOnlyMobbfun";
import { isGameflares, isGamiway } from "../constants/productCondition";
const arabicDomain = config.lang == "ar" ? true : false;
const kazakhDomain = config.lang == "kk" ? true : false;
const frenchDomain = config.lang == "fr" ? true : false;
const swedishDomain = config.lang == "sv" ? true : false;
const norwayhDomain = config.lang == "no" ? true : false;
const zaDomain = config.country == "za" ? true : false;
const asiacellDomain =
  config.subDomain == "iq" || config.subDomain == "asiacell" ? true : false;
const vietnamDomain = config.country == "vn" ? true : false;
const turkeyDomain = config.lang == "tr" ? true : false;
const spanishDomain = config.lang == "es" ? true : false;

class Welcome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSent: false,
    };
  }

  componentWillMount() {}
  componentDidMount() {
    document.body.classList.add("welcome-page-body");
    this.props.setHeaderTitle("!Más de 300 juegos html5 online!");
  }

  componentWillUnmount() {
    sendData("", "", "", "viewed", { page: "homepage" });
    document.body.classList.remove("welcome-page-body");
  }
  // redirect(){
  //     if (config.subDomain == 'mase' || config.subDomain == 'th'){
  //         setTimeout(() => {
  //             this.props.history.push(appendUid('/home/html', this.props.access.uid));
  //         }, 1000);
  //     }
  // }

  render() {
    let androidBtnStyle = {};
    if (asiacellDomain && !isGamiclub) {
      androidBtnStyle = {
        margin: "0 auto",
      };
    }
    let banner = [
      {
        imgUrl: "./img/stunt-driver-banner.jpg",
        offer: "Editors Choice",
        game_name: "Stunt Driver",
        category_name: "Racing Game",
      },
      {
        imgUrl: "./img/stund-driver.jpg",
        offer: "Editors Choice",
        game_name: "Clan Attack",
        category_name: "Action Game",
      },
    ];
    if (isGamiclub) {
      banner = [
        {
          imgUrl: "./img/Welcome-Page.png",
          offer: "",
          game_name: "",
          category_name: "",
        },
      ];
    } else if (config.lang == "ar") {
      banner[0].offer = "اختيار المحرر";
      banner[0].game_name = "السائق العنيد";
      banner[0].category_name = "لعبة السباق";
    } else if (config.lang == "cy") {
      banner[0].offer = "ИЗБОР УРЕДНИКА";
      banner[1].offer = "ИЗБОР УРЕДНИКА";
      banner[0].game_name = "STUNT DRIVER";
      banner[0].category_name = "ТРКАЧКА ИГРА";
    } else if (config.lang == "kk") {
      banner[0].offer = "Выбор редакции";
      banner[0].game_name = "Каскадер";
      banner[0].category_name = "Гонки";
    } else if (config.lang == "fr") {
      banner[0].offer = "CHOIX DES RÉDACTEURS";
      banner[0].game_name = "CASCADEUR";
      banner[0].category_name = "Jeu de course";
    } else if (config.lang == "sv") {
      banner[0].offer = "REDAKTÖRENS VAL";
      banner[0].game_name = "STUNTFÖRARE";
      banner[0].category_name = "Racingspel";
    } else if (config.lang == "no") {
      banner[0].offer = "REDAKTØRENS VALG";
      banner[0].game_name = "STUNT DRIVER";
      banner[0].category_name = "Racing-spill";
    } else if (config.country == "za") {
      banner[0].imgUrl = "./img/cricket-za.png";
      banner[0].offer = "";
      banner[0].game_name = "CRICKET BATTER";
      banner[0].category_name = "Sports Game";
    } else if (config.country == "vn") {
      banner[0].offer = "Sự lựa chọn hàng đầu";
      banner[0].game_name = "STUNT DRIVER";
      banner[0].category_name = "Game đua xe";
    } else if (config.lang == "tr") {
      banner[0].offer = "Editör’ün seçimi";
      banner[0].game_name = "STUNT DRIVER";
      banner[0].category_name = "Yarış oyunu";

      banner[1].offer = "Editör’ün seçimi";
      banner[1].game_name = "CLAN ATTACK";
      banner[1].category_name = "Macera oyunu";
    } else if (config.lang == "es") {
      banner[0].offer = "ELECCIÓN DEL EDITOR";
      banner[0].game_name = "CONDUCTOR DOBLE DE ACCIÓN";
      banner[0].category_name = "Juego de carreras";

      banner[1].offer = "ELECCIÓN DEL EDITOR";
      banner[1].game_name = "CLAN ATTACK";
      banner[1].category_name = "Juego Acción";
    } else if (config.lang == "it") {
      banner[0].offer = "SCELTI DALL EDITORE";
      banner[0].game_name = "STUNT DRIVER";
      banner[0].category_name = "GIOCO DI CORSE";

      banner[1].offer = "SCELTI DALL EDITORE";
      banner[1].game_name = "CLAN ATTACK";
      banner[1].category_name = "GIOCO DI AZIONE";
    } else if (config.lang == "el") {
      banner[0].offer = "ΕΠΙΛΟΓΗ ΠΡΟΣΩΠΙΚΟΥ Staff Choice";
      banner[1].offer = "ΕΠΙΛΟΓΗ ΠΡΟΣΩΠΙΚΟΥ Staff Choice";
    }
    const blackFridayBanner = {
      imgUrl: "./img/Swing_robber_R2.jpg",
      offer: "",
      game_name: "",
      category_name: "",
      id: 159,
      // id:31
    };
    if (config.subDomain == "idsale" || config.subDomain === "gmn") {
      banner = [blackFridayBanner];
      if (window.innerWidth < 768) banner[0].imgUrl = "./img/swing_robber.jpg";
    }

    return (
      <div>
        {(!isGamiclub && config.subDomain == "no") ||
        (isGamiclub && config.subDomain == "ch") ? (
          <button
            onClick={(e) => {
              sendData("", "", "", "WA chat clicked");
              window.open("https://wa.me/12028528006?text=Hello");
            }}
            className="whatsapp-button"
          >
            {" "}
            <img className="whatsapp-img" src="./img/whatsapp.png" />{" "}
          </button>
        ) : null}
        <div className="welcome-page">
          <Banner bannerData={banner} />
          <div className="category-options-wrap">
            <div className="category-options-inner">
              <Row className="justify-content-center">
                <Col xs="12">
                  <h6 className="explore-text white-text-color">
                    {isGamiclub ? (
                      <FormattedMessage
                        id="welcome.text.gamiclub"
                        defaultMessage="EXPLORE THE BEST CONTENT ONLINE TODAY!"
                      />
                    ) : (
                      <FormattedMessage
                        id="welcome.text"
                        defaultMessage="EXPLORE THE BEST MOBILE GAMES ONLINE TODAY!"
                      />
                    )}
                  </h6>
                  {config.subDomain === "es" && screen.width <= 768 && (
                    <h6 className="explore-text white-text-color">
                      !Más de 300 juegos html5 online!
                    </h6>
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col>
                  <div
                    className={`buttons-wrap ${
                      config.subDomain === "pe" ? "buttons-wrap-order" : ""
                    }`}
                  >
                    <div
                      className={`games-btn ${
                        isGameflares
                          ? "games-btn-gameflares-bg"
                          : config.subDomain === "pe"
                            ? "pe-games-btn"
                            : ""
                      }`}
                    >
                      <a href={appendUid("#/home/html", this.props.access.uid)}>
                        {isGamiclub || isGameflares || isGamiway ? (
                          <i
                            className={`fa fa-html5 ${
                              isGameflares
                                ? "fa-gradient-gameflares"
                                : isGamiway
                                  ? "fa-gradient-gamiway"
                                  : "fa-gradient-gamiclub"
                            }`}
                            aria-hidden="true"
                          ></i>
                        ) : (
                          <img
                            src="./img/icons/html5.svg"
                            style={{ width: "36px" }}
                            alt="HTML5 Games"
                          />
                        )}
                        <span className="btn-text">
                          <FormattedMessage id="html5" defaultMessage="HTML5" />
                          <span
                            style={
                              isGamiclub
                                ? { color: "lightgreen" }
                                : isGameflares
                                  ? { color: "#FF394B" }
                                  : isGamiway
                                    ? { color: "#b347a0" }
                                    : null
                            }
                            className="games-text"
                          >
                            <FormattedMessage
                              id="games"
                              defaultMessage="games"
                            />
                          </span>
                        </span>
                      </a>
                    </div>
                    {config.subDomain === "pe" && window.location.hostname.includes("game-lords.com") ? (
                      <div className={`games-btn pe-games-btn`} >
                        <a href={`https://pe-gamelord.striker-live.com/?uid=fdf098fcc6`} >
                          <img src="./img/wc_logo_transparent.png" style={{ width: "36px" }} alt="Football Live Score" />
                          <span className="btn-text world-cup-btn">
                            <FormattedMessage id="football-live-score-upper" defaultMessage="Football Live Score" />
                            <span className="games-text">
                              <FormattedMessage id="games" defaultMessage="games" />
                            </span>
                          </span>
                        </a>
                      </div>
                    ) : null }
                    {config.subDomain === "maae" ||
                    (config.subDomain === "za" && isIos) ||
                    (config.subDomain === "my" &&
                      window.location.hostname.includes("gamiclub.online")) ||
                    (config.subDomain === "ae" &&
                      window.location.hostname.includes(
                        "game-lords.com",
                      )) ? null : (
                      <div
                        className={`games-btn ${
                          isGameflares
                            ? "games-btn-gameflares-bg"
                            : config.subDomain === "pe"
                              ? "pe-games-btn"
                              : ""
                        }`}
                        style={androidBtnStyle}
                      >
                        <a
                          href={appendUid(
                            "#/home/android",
                            this.props.access.uid,
                          )}
                        >
                          {isGamiclub || isGameflares || isGamiway ? (
                            <i
                              className={`fa fa-html5 ${
                                isGameflares
                                  ? "fa-gradient-gameflares"
                                  : isGamiway
                                    ? "fa-gradient-gamiway"
                                    : "fa-gradient-gamiclub"
                              }`}
                              aria-hidden="true"
                            ></i>
                          ) : (
                            <img
                              src="./img/icons/android.svg"
                              style={{ width: "36px" }}
                              alt="Android Games"
                            />
                          )}
                          <span className="btn-text">
                            <FormattedMessage
                              id="android-upper"
                              defaultMessage="ANDROID"
                            />
                            <span
                              style={
                                isGamiclub
                                  ? { color: "lightgreen" }
                                  : isGameflares
                                    ? { color: "#FF394B" }
                                    : isGamiway
                                      ? { color: "#b347a0" }
                                      : null
                              }
                              className="games-text"
                            >
                              <FormattedMessage
                                id="games"
                                defaultMessage="games"
                              />
                            </span>
                          </span>
                        </a>
                      </div>
                    )}
                    {(isGamiclub &&
                      !(isOnlyMobbfun && config.subDomain === "id")) ||
                    config.subDomain === "za" ||
                    config.subDomain === "kw" ||
                    config.subDomain === "pt" ||
                    (config.subDomain === "id" && isGamiway) ? (
                      <div className="games-btn">
                        <a
                          href={appendUid(
                            "#/home/video",
                            this.props.access.uid,
                          )}
                        >
                          <i
                            className="fa fa-video-camera fa-gradient-gamiclub"
                            aria-hidden="true"
                            style={
                              isGamiway
                                ? { color: "#b347a0" }
                                : !isGamiclub
                                  ? { color: "#f3ab1b" }
                                  : isGameflares
                                    ? { color: "#FF394B" }
                                    : null
                            }
                          ></i>
                          <span className="btn-text">
                            <FormattedMessage
                              id="videos"
                              defaultMessage="VIDEOS"
                            />
                            <span
                              style={
                                isGamiclub
                                  ? { color: "lightgreen" }
                                  : isGameflares
                                    ? { color: "#FF394B" }
                                    : isGamiway
                                      ? { color: "#b347a0" }
                                      : null
                              }
                              className="games-text"
                            >
                              <FormattedMessage
                                id="vid-player"
                                defaultMessage="player"
                              />
                            </span>
                          </span>
                        </a>
                      </div>
                    ) : null}
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col xs="12">
                  <h6 className="white-text-color kazakh-text">
                    <FormattedMessage id="kazakhOnly" defaultMessage=" " />
                  </h6>
                </Col>
              </Row>
              {window.location.hostname.includes("funzarena") && (
                <h6 className="white-text-color kazakh-text">
                  <FormattedMessage
                    id="funzarena_text"
                    defaultMessage="You do not have access. Send a text message with the word GAME to 92505
(cost: PLN 30.75)"
                  />
                </h6>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      checkAccess,
      getDetails,
      getInterests,
      setHeaderTitle,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome.js